import { render } from "./PercentageIncrease.vue?vue&type=template&id=3b865484"
import script from "./PercentageIncrease.vue?vue&type=script&lang=js"
export * from "./PercentageIncrease.vue?vue&type=script&lang=js"

import "./PercentageIncrease.vue?vue&type=style&index=0&id=3b865484&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__